import styled from 'styled-components'

export const StyledHomepagevideos =styled.div`
overflow-y:scroll;
height: 88.7vh;
padding:1.6rem 1.5rem 2rem 0;
/* background: white; */
`;
export const RegularVidThumnailContainer =styled.div`
display: grid;
grid-template-columns: 1fr 1fr 1fr 1fr;
column-gap: 1rem;
row-gap: 3rem;
`;